import React, { Component } from 'react';
import Header from '../../components/Header';
import PageHeader from '../../components/PageHeader';
import ShortProductTable from './ShortProductTable';

class ShortProducts extends Component {

    state = {
        title: 'AOI 少货列表',
    }

    componentDidMount() {
        document.title = this.state.title;
    }

    render() {
        const { history } = this.props;

        return (
            <div className="App">
                <Header history={history} />
                <div id="page-wrapper">
                    <div className="container-fluid">
                        <PageHeader title={this.state.title} />
                        <div className="row">
                            <div className="col-lg-12">
                                <ShortProductTable />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ShortProducts;
